import { END_SESSION } from '../actions/authActions';
import { SET_SHIPPING_ADDRESSES } from '../actions/shippingAddressActions';
import { UNSUBSCRIBE_CURRENT_ACCOUNT } from '../actions/currentAccountActions';

const DEFAULT_STATE = [];

export default function shippingAddressesReducer(state = DEFAULT_STATE, { type, payload }) {
  switch (type) {
    case END_SESSION:
    case UNSUBSCRIBE_CURRENT_ACCOUNT:
      return DEFAULT_STATE;
    case SET_SHIPPING_ADDRESSES:
      return payload || DEFAULT_STATE;
    default:
      return state;
  }
}
